import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
class todoUnauthorized extends Component {
    constructor(props){
        super(props);
        this.state = {
            
        }
    }
    back() {
        window.location.href = '/todos/';
    }
    render(){
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
        }
        //console.log(this.props.match.params.todoId);
        return(
            <div >
            <Header brecum_name="" brecum_page=""/>
            <div class="right_col">
            <div class="intranet_body">
            <span style={{color: "red"}}>Sorry, this TO DO ID is restricted for public access</span>
            <div class='form-group'>
                <button className="btn btn-blue mob-btn" onClick={() => this.back()}>Back</button>
            </div>
            </div>
            </div>
            </div>
            
            
        )
    }
}

export default todoUnauthorized;



// WEBPACK FOOTER //
// ./src/components/todo/todoUnauthorized.js